import { render, staticRenderFns } from "./RcvL.vue?vue&type=template&id=397fa7f5"
import script from "./RcvL.vue?vue&type=script&lang=js"
export * from "./RcvL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports